import type { EntryPoint, EntryPointComponent, PreloadFetchPolicy } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import Query from './src/__generated__/UserSegmentationRedirectEntryQuery$parameters';
import type { UserSegmentationRedirectEntryQuery } from './src/__generated__/UserSegmentationRedirectEntryQuery.graphql';

const fetchPolicy: PreloadFetchPolicy = 'store-or-network';

export const userSegRedirectEntrypoint: EntryPoint<
	EntryPointComponent<{ userSegQueryRef: UserSegmentationRedirectEntryQuery }, {}, {}, {}>,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-user-seg-redirect-entrypoint" */ './src/UserSegmentationRedirectEntry'
			),
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			userSegQueryRef: {
				parameters: Query,
				variables: {
					accountId: tenantContext.atlassianAccountId || '',
					cloudId: tenantContext.cloudId,
				},
				options: {
					fetchPolicy,
				},
			},
		},
	}),
});
